import MultipleImgUrlUpload from './MultipleImgUrlUpload'

export default MultipleImgUrlUpload
